import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the userManagement state domain
 */

const selectUserManagementDomain = (state) =>
  state.get("userManagement", initialState)

/**
 * Other specific selectors
 */
export const makeSelectListUsers = () =>
  createSelector(selectUserManagementDomain, (state) => state.get("listUsers"))

export const makeSelectIsLoadingListUsers = () =>
  createSelector(selectUserManagementDomain, (state) =>
    state.get("isLoadingListUsers")
  )
/**
 * Default selector used by UserManagement
 */

const makeSelectUserManagement = () =>
  createSelector(selectUserManagementDomain, (substate) => substate.toJS())

export default makeSelectUserManagement
export { selectUserManagementDomain }
